import countries from "i18n-iso-countries";
import c2c from "country-to-currency";
import cc from "currency-codes";

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const alpha2Cache = new Map();
const defaultCurCache = new Map();
const alpha2ForCurCache = new Map();

const currencyFlagOverrides = {
  USD: "us",  // United States
  AUD: "au",  // Australia
  CAD: "ca",  // Canada
  NZD: "nz",  // New Zealand
  GBP: "gb",  // United Kingdom
  EUR: "eu",  // European Union
  JPY: "jp",  // Japan
  CNY: "cn",  // China
  INR: "in",  // India
};

export const alpha2 = (name) => {
  const key = name || "";
  if (alpha2Cache.has(key)) return alpha2Cache.get(key);

  const text = String(name || "").trim();
  let val = null;

  if (text) {
    if (/^[a-z]{2}$/i.test(text)) {
      val = text.toUpperCase();
    } else {
      try {
        const code = countries.getAlpha2Code(text, "en");
        val = code ? code.toUpperCase() : null;
      } catch {
        val = null;
      }
    }
  }

  alpha2Cache.set(key, val);
  return val;
};

export const defaultCurrencyForCountry = (countryName) => {
  const key = countryName || "";
  if (defaultCurCache.has(key)) return defaultCurCache.get(key);
  const a2 = alpha2(countryName);
  const val = a2 ? c2c[a2] || undefined : undefined;
  defaultCurCache.set(key, val);
  return val;
};

export const alpha2ForCurrency = (currencyCode) => {
  if (!currencyCode) return null;
  if (alpha2ForCurCache.has(currencyCode)) return alpha2ForCurCache.get(currencyCode);

  const info = cc.code(currencyCode);
  if (!info || !Array.isArray(info.countries) || info.countries.length === 0) {
    alpha2ForCurCache.set(currencyCode, null);
    return null;
  }
  const a2 = alpha2(info.countries[0]); 
  const val = a2 ? a2.toLowerCase() : null;
  alpha2ForCurCache.set(currencyCode, val);
  return val;
};

export const flagForCurrency = (currency, preferredCountryName) => {
  if (!currency) return null;

  if (currencyFlagOverrides[currency]) {
    return currencyFlagOverrides[currency];
  }

  const prefA2 = alpha2(preferredCountryName);
  if (prefA2 && defaultCurrencyForCountry(preferredCountryName) === currency) {
    return prefA2.toLowerCase();
  }

  return alpha2ForCurrency(currency);
};
